type NetworkInformation = {
  type?: string;
  effectiveType?: string;
  rtt?: number;
  downlink?: number;
  saveData?: boolean;
};

const interactions = ['pointerdown', 'pointermove', 'keydown', 'wheel', 'touchstart'];

/**
 * Tells the server this page ran in a browser, once someone interacts with it or leaves.
 * No cookies or identifiers beyond the page view id the server put in the page.
 */
export function startVisitBeacon(): void {
  const id = document.querySelector<HTMLMetaElement>('meta[name="fangmo-view"]')?.content;
  if (!id) return;
  let sent = false;
  const send = (interacted: boolean) => {
    if (sent) return;
    sent = true;
    for (const name of interactions) removeEventListener(name, onInteraction, true);
    const connection = (navigator as Navigator & { connection?: NetworkInformation }).connection;
    const body = JSON.stringify({
      v: id,
      interacted,
      webdriver: navigator.webdriver,
      screen: `${screen.width}x${screen.height}`,
      viewport: `${innerWidth}x${innerHeight}`,
      dpr: devicePixelRatio,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      language: navigator.language,
      touchPoints: navigator.maxTouchPoints,
      ...(connection
        ? {
            connection: {
              type: connection.type,
              effectiveType: connection.effectiveType,
              rtt: connection.rtt,
              downlink: connection.downlink,
              saveData: connection.saveData
            }
          }
        : {})
    });
    if (!navigator.sendBeacon?.('/v/beacon', body))
      void fetch('/v/beacon', { method: 'POST', body, keepalive: true }).catch(() => undefined);
  };
  // Script-dispatched events are not trusted; only real input counts as an interaction.
  // Chromium also sends a trusted pointermove that goes nowhere when the page under a resting
  // cursor changes, so a move counts only once the pointer has actually moved.
  const onInteraction = (event: Event) => {
    if (!event.isTrusted) return;
    const pointer = event as MouseEvent;
    if (event.type === 'pointermove' && !pointer.movementX && !pointer.movementY) return;
    send(true);
  };
  for (const name of interactions)
    addEventListener(name, onInteraction, { capture: true, passive: true });
  addEventListener('pagehide', () => send(false), { once: true });
}
